import { render, staticRenderFns } from "./AccountingBooksReceiptList.vue?vue&type=template&id=037f3ce5&"
import script from "./AccountingBooksReceiptList.vue?vue&type=script&lang=js&"
export * from "./AccountingBooksReceiptList.vue?vue&type=script&lang=js&"
import style0 from "./AccountingBooksReceiptList.vue?vue&type=style&index=0&id=037f3ce5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports